<template>
  <b-container class="my-4">
    <h2 class="mb-4">Completar misión de un usuario</h2>

    <b-card>
      <b-row class="mb-3">
        <b-col md="6">
          <label>Usuario</label>
          <multiselect
            v-model="selectedUser"
            label="email"
            track-by="id"
            placeholder="Busca por correo"
            :options="users"
            @input="loadMissions"
          />
        </b-col>
      </b-row>

      <div v-if="selectedUser">
        <b-table
          small
          striped
          hover
          selectable
          select-mode="single"
          :items="missions"
          :fields="fields"
          :busy="loading"
          show-empty
          empty-text="El usuario no tiene misiones"
          @row-selected="onSelect"
        >
          <template #cell(completed)="row">
            <b-badge :variant="row.item.completed ? 'success' : 'secondary'">
              {{ row.item.completed ? "Completada" : "Pendiente" }}
            </b-badge>
          </template>
          <template #cell(rewards)="row">
            <span v-if="!rewardsText(row.item)" class="text-muted">—</span>
            <span v-else>{{ rewardsText(row.item) }}</span>
          </template>
        </b-table>

        <b-alert v-if="selected" show variant="light" class="mt-2">
          <p class="mb-2">
            Se completará <strong>{{ selected.mission.title }}</strong> y se
            entregarán:
            {{ rewardsText(selected) || "sin usos de servicios" }},
            {{ selected.mission.experience_reward }} XP.
          </p>
          <b-button variant="primary" :disabled="saving" @click="complete">
            {{ saving ? "Entregando..." : "Completar y entregar recompensas" }}
          </b-button>
        </b-alert>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import informationService from "../../../services/informationService";
import missionService from "../../../services/missionService";

const REWARD_LABELS = {
  planifications_uses: "Planificaciones",
  materials_uses: "Materiales",
  documents_uses: "Documentos",
  tests_uses: "Corrección de Tests",
  eureka_uses: "Eureka",
};

export default {
  created() {
    informationService.getUsers().then((data) => {
      this.users = data.users;
    });
  },
  data() {
    return {
      users: [],
      selectedUser: null,
      missions: [],
      selected: null,
      loading: false,
      saving: false,
      fields: [
        { key: "mission.title", label: "Misión" },
        { key: "rewards", label: "Recompensas" },
        { key: "completed", label: "Estado" },
      ],
    };
  },
  methods: {
    rewardsText(userMission) {
      return (userMission.mission.special_rewards || [])
        .map((r) => `${REWARD_LABELS[r.field] || r.field}: ${r.uses}`)
        .join(", ");
    },
    onSelect(rows) {
      // las completadas no se pueden volver a entregar
      const row = rows[0];
      this.selected = row && !row.completed ? row : null;
    },
    loadMissions() {
      this.selected = null;
      this.missions = [];
      if (!this.selectedUser) return;
      this.loading = true;
      missionService
        .getUserMissions(this.selectedUser.id)
        .then((data) => {
          this.missions = data;
        })
        .catch(() => this.$toasted.error("No se pudieron cargar las misiones"))
        .finally(() => {
          this.loading = false;
        });
    },
    complete() {
      this.saving = true;
      missionService
        .completeUserMission(this.selected.id)
        .then((data) => {
          this.$toasted.success(data.message);
          this.loadMissions();
        })
        .catch((error) => {
          this.$toasted.error(
            (error.response && error.response.data.message) ||
              "No se pudo completar la misión"
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
